import { render } from "./DataAnalytics.vue?vue&type=template&id=b00e3aee&scoped=true"
import script from "./DataAnalytics.vue?vue&type=script&lang=js"
export * from "./DataAnalytics.vue?vue&type=script&lang=js"

import "./DataAnalytics.vue?vue&type=style&index=0&id=b00e3aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00e3aee"]])

export default __exports__